import { getLocalizedPath } from '@main/internationalization';
import { LanguageKey } from '@transcend-io/internationalization';
import React from 'react';
import { useIntl } from 'react-intl';
import { RouteProps, Routes } from 'react-router-dom';

/**
 * A localized switch for
 */
export const LocalizedSwitch: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { locale } = useIntl();

  /**
   * Localize the route
   *
   * @param path - can be string, undefined or string array
   * @returns Localized string path or path array
   */
  function localizeRoutePath(
    path?: string | readonly string[],
  ): string | string[] | undefined {
    switch (typeof path) {
      case 'undefined':
        return undefined;
      case 'object':
        return path.map((key) => getLocalizedPath(key, locale as LanguageKey));
      default:
        // If fallback?
        return path === '*'
          ? path
          : getLocalizedPath(path, locale as LanguageKey);
    }
  }

  /**
   * Apply localization to all routes
   * Also checks if all children elements are <Route /> components
   */
  return (
    <Routes>
      {React.Children.map(children, (child) =>
        React.isValidElement<RouteProps>(child)
          ? [
              // Accept the original route
              child,
              // Accept route with locale
              React.cloneElement(child, {
                ...child.props,
                path: localizeRoutePath(child.props.path) as string,
              }),
            ]
          : child,
      )?.flat()}
    </Routes>
  );
};
